import type { Province } from '../types/province';

/**
 * SF-141: shared current-tick-elapsed fraction derivation, extracted from the identical two-line
 * computation previously hand-copied in MobileBuildingsShell.tsx and MobileExploreShell.tsx. Any
 * in-progress timer field (Construction/Exploration/Training) decrements in lockstep with one
 * shared global tick, so this formula applies verbatim regardless of which entity list it's
 * paired with.
 */
export function deriveReturnTimeFraction(sync: Pick<Province['sync'], 'currentTickStartedAt' | 'tickIntervalMs'>): number {
  if (!Number.isFinite(sync.tickIntervalMs) || sync.tickIntervalMs <= 0) return 0;
  const msIntoCurrentTick = Date.now() - new Date(sync.currentTickStartedAt).getTime();
  if (!Number.isFinite(msIntoCurrentTick)) return 0;
  return 1 - clamp(msIntoCurrentTick / sync.tickIntervalMs, 0, 1);
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
